import { ReactElement, useEffect } from 'react';

import { useOidc } from '@changegps/access-identity';
import { LandingPage } from '@changegps/horizon-component-library';
import { Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useTitle } from '@/hooks';

import AccessCGPSLogo from '../../../../../assets/logo/cgps-logo-v2-horizontal.svg';
import {
  AccessLoginButton,
  AccessRegisterButton,
  RightPanel,
} from '../components';

export const Login = (): ReactElement => {
  useTitle('Login');

  const navigate = useNavigate();
  const location = useLocation();

  const { login, getUser } = useOidc();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const error = params.get('error');
    if (error === 'invalid_credentials') {
      toast.error('Invalid credentials');
    }

    void getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return (
    <LandingPage rightPanel={<RightPanel />} split footerVisible>
      <Stack component="form" width={'330px'} spacing={3}>
        <Stack alignItems="center" justifyContent="space-between">
          <img src={AccessCGPSLogo} height={83} width={192} />
        </Stack>
        <AccessLoginButton fullWidth onClick={login}>
          Login with Access Cloud
        </AccessLoginButton>
        <Stack alignItems="center">
          <Typography>or</Typography>
        </Stack>
        <AccessRegisterButton
          fullWidth
          onClick={() =>
            navigate('/signup/company-info', { state: { cid: '' } })
          }
        >
          Sign up
        </AccessRegisterButton>
      </Stack>
    </LandingPage>
  );
};
